// W-019: ログアウト

export const PageRoutes = {
  HOME: "/", // W-001
  // Activation
  PASSWORD_SETTING: "/password_setting", // W-027
  PHONE_NUMBER_SETTING: "/phone_number_setting", // W-028
  // Auth
  LOGIN: "/login", // W-020
  LOGIN_PASSWORD: "/login_password", // W-031
  LOGIN_PASSKEY: "/login_passkey", // W-026
  FORGOT_PASSWORD: "/forgot_password", // W-029
  FORGOT_PASSWORD_SEND_MAIL: "/forgot_password_send_mail",
  EASY_LOGIN: "/easy_login", // W-024
  PASSKEY_SETTING: "/passkey_setting", // W-025
  PASSKEY_SETTING_COMPLETE: "/passkey_setting_complete", // W-032
  // Activation + Auth
  SMS_SEND: "/sms_send", // W-021
  SMS_SEND_COMPLETE: "/sms_send_complete", // W-022
  SMS_REGISTRATION: "/sms_registration", // W-023
  SMS_REGISTRATION_COMPLETE: "/sms_registration_complete", // W-033
  EMAIL_SEND: "/email_send",
  EMAIL_SEND_COMPLETE: "/email_send_complete",
  EMAIL_REGISTRATION: "/email_registration",
  EMAIL_REGISTRATION_COMPLETE: "/email_registration_complete",
  // Reset Password
  RESET_PASSWORD: "/reset_password/:token", // W-030
  RESET_PASSWORD_COMPLETE: "/reset_password_complete", // W-034
  RESET_PASSWORD_TIMEOUT: "/reset_password_timeout", // W-035
  // Account Management
  CLIENTS: "/clients", // W-007
  CLIENT_DETAIL: "/clients/:clientId", // W-008
  CLIENT_REGISTRATION: "/clients/registration", // W-009
  CLIENT_EDIT: "/clients/edit/:clientId", // W-010
  GROUPS: "/groups", // W-011
  GROUP_DETAIL: "/groups/:groupId", // W-012
  GROUP_REGISTRATION: "/groups/registration", // W-013
  GROUP_EDIT: "/groups/edit/:groupId", // W-014
  USERS: "/users", // W-015
  USER_DETAIL: "/users/:userId", // W-016
  USER_REGISTRATION: "/users/registration", // W-017
  USER_EDIT: "/users/edit/:userId", // W-018
  // File Upload
  FILE_UPLOAD: "/file_upload/:menuId", // W-003 W-004 W-005
  FILE_UPLOAD_RESULT: "/file_upload_result", // W-006
  MAINTENANCE: "/maintenance", // W-036
  NOT_FOUND: "*",
};

export const FILE_UPLOAD = {
  COMMON_HUMAN_RESOURCE: "1",
  COMMON_RESERVATION: "2",
  INDIVIDUAL_HUMAN_RESOURCE: "3",
};
